<template>
  <div class="flex flex-col gap-6">
    <!-- Page Header -->
    <div class="flex items-center justify-between">
      <div>
        <h1 class="text-2xl font-bold text-slate-800">项目限项审查</h1>
        <p class="text-sm text-slate-500 mt-1">核查申请人当前在研项目数量是否超出国拨限项规定</p>
      </div>
      <div class="flex items-center gap-3">
        <span class="px-3 py-1.5 bg-blue-50 text-blue-600 rounded-full text-xs font-semibold">申报初审</span>
        <span class="px-3 py-1.5 bg-emerald-50 text-emerald-600 rounded-full text-xs font-semibold">无问题</span>
      </div>
    </div>

    <!-- Main Content Card -->
    <div class="glass-card rounded-3xl p-6">
      <!-- Section 1: Check Items -->
      <div class="mb-8">
        <div class="flex items-center gap-2 mb-4">
          <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center">
            <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
            </svg>
          </div>
          <h2 class="text-lg font-bold text-slate-800">审查项配置</h2>
        </div>
        <p class="text-sm text-slate-500 mb-4 ml-10">选择需要审查的限项项目，系统将对申报书进行多维度限项审查</p>

        <div class="ml-10 space-y-3">
          <label class="flex items-center gap-4 p-4 rounded-xl cursor-pointer border-2 transition-all duration-300" 
                 :class="selectedChecks.includes('leader') ? 'border-blue-500 bg-blue-50/30' : 'border-slate-200 bg-white hover:border-blue-300'"
                 @click="toggleCheck('leader')">
            <div class="w-10 h-10 rounded-xl flex items-center justify-center transition-colors"
                 :class="selectedChecks.includes('leader') ? 'bg-blue-500 text-white' : 'bg-slate-100 text-slate-500'">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
            </div>
            <div class="flex-1">
              <div class="flex items-center gap-2">
                <h3 class="text-sm font-semibold transition-colors" 
                    :class="selectedChecks.includes('leader') ? 'text-blue-700' : 'text-slate-700'">项目负责人限项审查</h3>
                <div class="w-2 h-2 rounded-full transition-colors"
                     :class="selectedChecks.includes('leader') ? 'bg-emerald-500' : 'bg-slate-300'"></div>
              </div>
              <p class="text-xs text-slate-500 mt-1">核查项目负责人在研项目数量是否超出国拨限项规定</p>
            </div>
          </label>

          <label class="flex items-center gap-4 p-4 rounded-xl cursor-pointer border-2 transition-all duration-300" 
                 :class="selectedChecks.includes('member') ? 'border-blue-500 bg-blue-50/30' : 'border-slate-200 bg-white hover:border-blue-300'"
                 @click="toggleCheck('member')">
            <div class="w-10 h-10 rounded-xl flex items-center justify-center transition-colors"
                 :class="selectedChecks.includes('member') ? 'bg-blue-500 text-white' : 'bg-slate-100 text-slate-500'">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
            </div>
            <div class="flex-1">
              <div class="flex items-center gap-2">
                <h3 class="text-sm font-semibold transition-colors" 
                    :class="selectedChecks.includes('member') ? 'text-blue-700' : 'text-slate-700'">项目成员限项审查</h3>
                <div class="w-2 h-2 rounded-full transition-colors"
                     :class="selectedChecks.includes('member') ? 'bg-emerald-500' : 'bg-slate-300'"></div>
              </div>
              <p class="text-xs text-slate-500 mt-1">核查项目主要参与人员在研项目数量是否符合规定</p>
            </div>
          </label>

          <label class="flex items-center gap-4 p-4 rounded-xl cursor-pointer border-2 transition-all duration-300" 
                 :class="selectedChecks.includes('duplicate') ? 'border-blue-500 bg-blue-50/30' : 'border-slate-200 bg-white hover:border-blue-300'"
                 @click="toggleCheck('duplicate')">
            <div class="w-10 h-10 rounded-xl flex items-center justify-center transition-colors"
                 :class="selectedChecks.includes('duplicate') ? 'bg-blue-500 text-white' : 'bg-slate-100 text-slate-500'">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"/>
              </svg>
            </div>
            <div class="flex-1">
              <div class="flex items-center gap-2">
                <h3 class="text-sm font-semibold transition-colors" 
                    :class="selectedChecks.includes('duplicate') ? 'text-blue-700' : 'text-slate-700'">重复申报审查</h3>
                <div class="w-2 h-2 rounded-full transition-colors"
                     :class="selectedChecks.includes('duplicate') ? 'bg-emerald-500' : 'bg-slate-300'"></div>
              </div>
              <p class="text-xs text-slate-500 mt-1">检查是否存在同一项目重复申报的情况</p>
            </div>
          </label>
        </div>
      </div>

      <!-- Section 2: Input -->
      <div class="mb-8">
        <div class="flex items-center gap-2 mb-4">
          <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center">
            <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
          </div>
          <h2 class="text-lg font-bold text-slate-800">申报书信息输入</h2>
        </div>
        <p class="text-sm text-slate-500 mb-4 ml-10">输入申报书内容或上传文件，进行项目限项审查分析</p>

        <div class="ml-10">
          <div class="relative">
            <textarea
              v-model="declarationContent"
              class="premium-input w-full h-40 rounded-2xl p-5 text-sm leading-relaxed resize-none"
              placeholder="请粘贴申报书内容..."
            ></textarea>
            <div class="absolute bottom-4 right-4 text-xs text-slate-400">
              {{ declarationContent.length }} 字符
            </div>
          </div>

          <div class="mt-4 flex items-center gap-4">
            <button class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 hover:bg-slate-200 rounded-xl text-sm font-medium text-slate-600 transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
              </svg>
              上传文件
            </button>
            <span class="text-xs text-slate-400">支持 PDF、DOCX 格式</span>
          </div>
        </div>
      </div>

      <!-- Action Button -->
      <div class="flex justify-center">
        <button class="btn-action px-10 py-4 rounded-2xl text-white font-bold text-base flex items-center gap-3">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
          </svg>
          启动限项审查
        </button>
      </div>
    </div>

    <!-- Check Results -->
    <div class="glass-card rounded-3xl p-6">
      <div class="flex items-center justify-between mb-6">
        <div class="flex items-center gap-2">
          <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center">
            <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
            </svg>
          </div>
          <h2 class="text-lg font-bold text-slate-800">审查结果</h2>
        </div>
        <button class="btn-export px-4 py-2 rounded-xl text-white text-sm font-medium flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
          </svg>
          导出报告
        </button>
      </div>

      <!-- Limit Check Title -->
      <h3 class="text-xl font-bold text-slate-800 mb-4">项目限项审查</h3>

      <div class="space-y-4">
        <!-- Limit Check Result - No Issues -->
        <div class="p-4 bg-emerald-50 border border-emerald-200 rounded-xl">
          <div class="flex items-start gap-3">
            <div class="w-8 h-8 rounded-lg bg-emerald-500 flex items-center justify-center flex-shrink-0">
              <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
            </div>
            <div class="flex-1">
              <h4 class="font-semibold text-emerald-800 text-sm">检查结果：无问题</h4>
              <p class="text-xs text-emerald-600 mt-1">经核查，项目负责人及主要参与人员在研项目数量未超过限项规定，符合申报条件。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeclareLimitCheck',
  data() {
    return {
      selectedChecks: ['leader', 'member', 'duplicate'],
      declarationContent: ''
    }
  },
  methods: {
    toggleCheck(check) {
      const index = this.selectedChecks.indexOf(check)
      if (index > -1) {
        this.selectedChecks.splice(index, 1)
      } else {
        this.selectedChecks.push(check)
      }
    }
  }
}
</script>